import cn from 'classnames';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getIsCartTotalFetching from 'store/cart/selector/getIsCartTotalFetching';
import GoToCheckoutButton from './GoToCheckoutButton/GoToCheckoutButton';
import styles from './OrderSummary.module.scss';
import OrderSummaryBreakDown from './OrderSummaryBreakDown/OrderTotalBreakDown';
import OrderTotal from './OrderTotal/OrderTotal';
import PaymentMethods from './PaymentMethods/PaymentMethods';
import Vouchers from './Vouchers/Vouchers';

interface OrderSummaryProps {
  onApplyVoucher: (voucherCode: string) => void;
  onRemoveVoucher: (voucherId: string) => void;
  onCheckout: () => void;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ onApplyVoucher, onRemoveVoucher, onCheckout }) => {
  const fetchingTotal = useSelector(getIsCartTotalFetching);
  const { t } = useTranslation();
  return (
    <div
      className={cn(styles.orderSummary, {
        [styles.loading]: fetchingTotal,
      })}
    >
      <OpText variant="title" size="large">
        {t('txt_heading_order_summary')}
      </OpText>
      <OrderSummaryBreakDown />
      <Vouchers onApplyVoucher={onApplyVoucher} onRemoveVoucher={onRemoveVoucher} />
      <hr />
      <OrderTotal />
      <GoToCheckoutButton onCheckout={onCheckout} />
      <PaymentMethods />
    </div>
  );
};

export default OrderSummary;
